module.exports = __webpack_public_path__ + "media/bgm.d97ae795.mp3";